module.exports = __webpack_public_path__ + "img/Seite26-default.97046525.png";